// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".set-default-app-container .spinner-container{padding-top:16px}", "",{"version":3,"sources":["/usr/local/ado-agent/_work/1/s/src/components/settings/set-default-app/set-default-app.scss"],"names":[],"mappings":"AAGE,8CACE,gBAAA","file":"set-default-app.scss","sourcesContent":["@import '~gazelle/src/style/variables';\n\n.set-default-app-container {\n  .spinner-container {\n    padding-top: 16px;\n  }\n}\n"]}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
